import { render, staticRenderFns } from "./ReservationAcceptReject.vue?vue&type=template&id=965427f4"
import script from "./ReservationAcceptReject.vue?vue&type=script&lang=js"
export * from "./ReservationAcceptReject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports